import TrackingManager from '@ingeniorforeningen/tracking';
import { SeverityLevel } from '@ingeniorforeningen/tracking/build/appInsights';

const useGtmProdContainer = process.env.NEXT_PUBLIC_USE_GTM_PROD_CONTAINER === 'true';
const trackingLanguage = 'da';
const domain = 'ida.dk';

const tracker = () => {
  TrackingManager.init(useGtmProdContainer, domain, trackingLanguage);

  return {
    trackPageView: (metadata: { header: string; nodeId: number }) => {
      if (metadata) {
        TrackingManager.Instance.page.view({
          pageTitle: metadata.header,
          nodeId: metadata.nodeId.toString(),
          section: 'ida konferencer',
        });
      }
    },
    trackPageError: (errorcode: number, properties?: Record<string, unknown>) => {
      TrackingManager.Instance.page.error({
        errorcode,
        properties,
        severityLevel: SeverityLevel.Error,
      });
    },
  };
};

export default tracker;
